module.exports = __webpack_public_path__ + "static/media/no-filter-results.130c1f7a.svg";